// Module
var code = "<a data-bind=\"click: Click, enableAttr: _enabled, style: _style\" tabindex=\"-1\" href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-security-reset securityReset-button\"> <i class=\"fa fa-lock\"></i><span><!-- ko text: _labels.RESET_SECURITY --><!-- /ko --></span> </a>";
// Exports
export default code;